import { StatementPayload, createLangString } from '@/app/tracking/xapi/tincan/client';

export interface SectionExperiencedStatementParams {
  id: string;
  title: string;
  description?: string;
}

export function createSectionExperiencedStatement(params: SectionExperiencedStatementParams) {

  const statement: StatementPayload = {
    verb: {
      id: 'http://adlnet.gov/expapi/verbs/experienced',
      display: {
        'en-US': 'experienced'
      }
    },
    object: {
      objectType: 'Activity',
      id: params.id,
      definition: {
        type: 'http://adlnet.gov/expapi/activities/module',
        name: createLangString(params.title),
        description: params.description ? createLangString(params.description) : undefined
      }
    }
  };

  return statement;
}
